// frontend/src/utils/research.ts
//
// The conviction signal (STRATEGY C-ENG2 / H3 Edge 2). ONE event name with a
// typed Research Type property, so the post-pilot correlation matrix can test
// BOTH the aggregate (research actions per user-week vs subsequent
// `League Created`) AND the decomposition (WHICH action type predicts).
// Research-intensity -> commissioner conversion is a HYPOTHESIS to test,
// never a KPI to optimize before the correlation is proven.
//
// Surface is derived from the URL so shared components (profile modal, score
// breakdown) need no prop threading and every surface - including the
// anonymous pre-signup bar scanner - is covered automatically.

import { mixpanelTrack } from '@/services/mixpanel';

export type ResearchType =
  | 'profile'              // player profile modal opened
  | 'profile_game_log'     // game log tab selected inside the modal
  | 'profile_season_stats' // season stats tab selected inside the modal
  | 'profile_projections'  // projections tab selected inside the modal
  | 'profile_league_activity' // league Activity (roster history) tab selected inside the modal
  | 'score_breakdown'      // score breakdown modal opened
  | 'stats_page_view'      // /stats visited
  | 'stats_sort'           // /stats column sorted
  | 'stats_filter'         // /stats position/team filter used
  | 'stats_search';        // /stats player search (debounced, non-empty)

const surfaceFromPath = (pathname: string): string => {
  if (pathname.startsWith('/dfs/build')) return 'dfs_builder';
  if (pathname.startsWith('/dfs/contest')) return 'dfs_scorecard';
  if (pathname.startsWith('/leagues') || pathname.startsWith('/season-long')) return 'league';
  if (pathname.startsWith('/classic')) return 'classic';
  if (pathname.startsWith('/stats')) return 'stats_page';
  if (pathname.startsWith('/blog')) return 'blog';
  return 'other';
};

export const trackPlayerResearch = (
  researchType: ResearchType,
  props?: Record<string, unknown>,
): void => {
  mixpanelTrack('Player Research', {
    'Research Type': researchType,
    'Surface': surfaceFromPath(window.location.pathname),
    ...props,
  });
};
